import React from 'react';
import App from './App';
import { render } from 'react-dom';
import registerServiceWorker from './registerServiceWorker';

const rootElement = document.getElementById( 'root' );
render( <App />, rootElement );
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js